import { LOGIN_STATUS } from "./Types";

const initialState = {
	login: [],
};

const loginReducer = (state = initialState, action) => {
	console.log(action, "action");
	switch (action.type) {
		case LOGIN_STATUS:
			console.log(action.payload, "LOGIN reducers");
			return {
				...state,
				login: action.payload,
			};
		default:
			return state;
	}
};

export default loginReducer;
